export const LEFT_NAV_TOGGLE_EXPAND = 'LEFT_NAV_TOGGLE_EXPAND';
export const BURGER_MENU_TOGGLE_EXPAND = 'BURGER_MENU_TOGGLE_EXPAND';
